// extracted by mini-css-extract-plugin
export default {"backgroundWrapper":"pageContainer_backgroundWrapper__Z-RwQ","fixedTopArea":"pageContainer_fixedTopArea__KCkJX","scrollArea":"pageContainer_scrollArea__Xw-dF"};